export default __webpack_public_path__ + "static/media/defendant-legal-team-defendant.5b39e61b.jpg";